const StatusText = {
    FILTER: {
        sortAndFilter: {
            english: 'Sort and filter',
            spanish: 'Clasificar y filtrar',
        },
        filter: {
            english: 'Filter:',
            spanish: 'Filtrar',
        },
        all: {
            english: 'All',
            spanish: 'Todo',
        },
        claims: {
            english: 'Claims',
            spanish: 'Reclamos',
        },
        leaves: {
            english: 'Leaves',
            spanish: 'Licencias',
        },
        sort: {
            english: 'Sort:',
            spanish: 'Clasificar:',
        },
        eventNumber: {
            english: 'Event #',
            spanish: 'Evento #',
        },
        product: {
            english: 'Product',
            spanish: 'Producto',
        },
        recDate: {
            english: 'Rec. date',
            spanish: 'Fecha de rec.',
        },
        detDate: {
            english: 'Det. date',
            spanish: 'Fecha de det.',
        },
        status: {
            english: 'Status',
            spanish: 'Estado',
        },
        selected: {
            english: 'Selected',
            spanish: 'Seleccionado',
        },
        notSelected: {
            english: 'Not selected',
            spanish: 'No seleccionado',
        },
    },
    LINKS: {
        returnToWork: {
            english: 'Return to work',
            spanish: 'Volver al trabajo',
        },
        viewDetails: {
            english: 'View details',
            spanish: 'Ver detalles',
        },
        uploadDocuments: {
            english: 'Upload documents',
            spanish: 'Subir documentos',
        },
    },
    ALERTS: {
        noClaimsOrLeaves: {
            english: 'No claims or leaves were found',
            spanish: 'No se encontraron reclamaciones ni hojas.',
        },
        fetchClaimsErrorER: {
            english: 'Something went wrong while retrieving claims and leaves for this employee',
            spanish: 'Algo salió mal al recuperar reclamos y licencias para este empleado',
        },
        fetchClaimsErrorEE: {
            english: 'Something went wrong while retrieving your claims and leaves',
            spanish: 'Algo salió mal al recuperar tus reclamos y permisos.',
        },
    },
    FIELDS: {
        eventNumberText: {
            english: 'Event no.',
            spanish: 'Evento no.',
        },
        receivedDateText: {
            english: 'Received date',
            spanish: 'Fecha de recepción',
        },
        determinationDateText: {
            english: 'Determination date',
            spanish: 'Fecha de determinación',
        },
        leaveCategoryText: {
            english: 'Leave category',
            spanish: 'Categoría de licencia',
        },
        leaveReason: {
            english: 'Leave reason',
            spanish: 'Motivo de la licencia',
        },
        leaveBeginDate: {
            english: 'Leave begin',
            spanish: 'Fecha de inicio de licencia',
        },
        leaveEndDate: {
            english: 'Leave end',
            spanish: 'Fecha de finalización de licencia',
        },
        disabilityCause: {
            english: 'Disability cause',
            spanish: 'Causa de discapacidad',
        },
        dateOfDisability: {
            english: 'Date of disability',
            spanish: 'Fecha de discapacidad',
        },
        approvedThroughDate: {
            english: 'Approved through date',
            spanish: 'Fecha límite de aprobación',
        },
        approvedToDate: {
            english: 'Approved to date',
            spanish: 'Aprobado hasta la fecha',
        },
        dateDisclaimer: {
            english: 'The approved through date is dependent upon the claimant continuing to meet the definition of disability under contract/plan provisions and therefore, is subject to change.',
            spanish: 'La fecha límite aprobada depende de que el demandante continúe cumpliendo la definición de discapacidad según las provisiones del contrato/plan y, por lo tanto, está sujeto a cambio.',
        },
    },
    COVERAGE: {
        STD: {
            english: 'Short term disability',
            spanish: 'Incapacidad a corto plazo',
        },
        LTD: {
            english: 'Long term disability',
            spanish: 'Incapacidad a largo plazo',
        },
        STAT: {
            english: 'Statutory Disability',
            spanish: 'Incapacidad legal',
        },
        paidLeave: {
            english: 'Paid leave',
            spanish: 'Licencia paga',
        },
        leave: {
            english: 'Leave',
            spanish: 'Licencia',
        },
    },
    showMore: {
        english: 'Show more',
        spanish: 'Mostrar más',
    },
    showLess: {
        english: 'Show less',
        spanish: 'Mostrar menos',
    },
};
export default StatusText;
